import React from 'react';

const Header = () => {
  return (
    <header>
      {/* <h1>Webgems</h1> */}
      {/* <p>Show your appreciation</p> */}
    </header>
  );
};

export default Header;
